import Rest from '@/services/Rest';

/**
 * @typedef {AttachmentsService}
 */
export default class AttachmentsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/attachment/preview'
}
